import apiSvc from '../services/apiSvc';

// endpoints
const GET_LIST = 'admin/vendor/list';

// DEFINITION
const adminVendorRepo = {
    getList,
};

async function getList(): Promise<any[]> {
    return await apiSvc.getEntityList(GET_LIST, {});
}

export default adminVendorRepo;
